import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useLazyQuery } from '@apollo/client';
import { CALCULATE_GROUP_PANEL_STAGES } from 'api/queries/enrollmentService';
import { getRootStoreInstance } from 'store/rootStore';
import { FilterTitleObject, GroupFilter } from 'types/groupService';
import { GROUPS_FILTERS_TITLES } from 'global/utils/DashboardFilters';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import FilterCard from '../../common/group/content/FilterCard';
import { FilterListStyled } from './styles';

function getFilteredGroupTitles(): FilterTitleObject<GroupFilter> {
  const availableFilters =
    getRootStoreInstance().domainStoreV2.domainHeader.properties?.availablePipelineStatuses ||
    (Object.keys(GROUPS_FILTERS_TITLES) as GroupFilter[]);

  // Create a new object
  return Object.fromEntries(
    availableFilters.map((filter) => [filter, GROUPS_FILTERS_TITLES[filter]]),
  ) as FilterTitleObject<GroupFilter>;
}

const FiltersPanel: React.FC = observer(() => {
  const { groupRequestParams, setFilter, groups } = useGroupDashboardPageStore();

  const [calculateCardValuesForGroupStageStatus, { data: groupData = { calculateCardValuesForGroupStageStatus: {} } }] =
    useLazyQuery<{
      calculateCardValuesForGroupStageStatus: Record<string, string>;
    }>(CALCULATE_GROUP_PANEL_STAGES, {
      variables: {
        fullView: groupRequestParams.fullView,
      },
      fetchPolicy: 'no-cache',
    });

  const onSetActiveFilter = (ownFilter: GroupFilter): void => {
    setFilter(ownFilter);
  };

  const groupStageStatuses = groupData.calculateCardValuesForGroupStageStatus;

  useEffect(() => {
    void calculateCardValuesForGroupStageStatus();
  }, [groups, groupRequestParams.fullView]);

  return (
    <FilterListStyled role="menu">
      {Object.keys(getFilteredGroupTitles()).map((filterKey) => (
        <FilterCard
          title={GROUPS_FILTERS_TITLES[filterKey as GroupFilter]}
          ownFilter={filterKey as GroupFilter}
          quantity={groupStageStatuses[filterKey] || '0'}
          activeFilter={groupRequestParams.filter}
          onSetFilter={onSetActiveFilter}
          key={filterKey}
        />
      ))}
    </FilterListStyled>
  );
});

export default FiltersPanel;
